module.exports = __webpack_public_path__ + "static/daigoji-main-755b3b267c65f117db1bc88b854b6670.jpg";